import {createSelector} from "reselect";

const getAuth = (state) => state.get('auth');
export const getAuthSelector = createSelector(
  [getAuth],
  (auth) => auth.toJS()
);
const getInvestmentPlatform = (state) => state.get('investmentPlatform');
export const getInvestmentPlatformSelector = createSelector(
  [getInvestmentPlatform],
  (investmentPlatform) => investmentPlatform.toJS()
);

const getCustomerDashboard = (state) => state.get('customerDashboard');
export const getCustomerDashboardSelector = createSelector(
  [getCustomerDashboard],
  (customerDashboard) => customerDashboard.toJS()
);

const getSharedSettings = (state) => state.get('sharedSettings');
export const getSharedSettingsSelector = createSelector(
  [getSharedSettings],
  (sharedSettings) => sharedSettings.toJS()
);

export const getAlertingNotificationsCountSplitted = createSelector(
  [getInvestmentPlatform],
  (investmentPlatform) => {
    return investmentPlatform.toJS().new_alerting_events_count || {};
  }
);

const getGuide = (state) => state.get('guide');

export const getGuideSelector = createSelector(
  [getGuide],
  (guide) => guide.toJS()
);

const getBenchmarkConfiguration = (state) => state.get('benchmarkConfiguration');
export const getBenchmarkConfigurationSelector = createSelector(
  [getBenchmarkConfiguration],
  (benchmarkConfiguration) => benchmarkConfiguration.toJS()
);

const getSnackbar = (state) => state.get('snackbar');
export const getSnackbarSelector = createSelector(
  [getSnackbar],
  (snackbar) => snackbar.toJS()
);